/**
 * Locale metadata and the list of routes that carry a translation.
 *
 * Only the corporate pages and the Newsroom index are translated. Investor
 * Relations and the legal pages stay in English, and so do the press release
 * articles themselves at /newsroom/<slug>: announcement titles, bodies and
 * documents are the official record as released to SGXNet and must not be
 * restated in another language.
 */
export const LOCALES = [
  { code: 'en', label: 'English', short: 'EN', htmlLang: 'en-SG', hrefLang: 'en' },
  { code: 'ms', label: 'Bahasa Melayu', short: 'BM', htmlLang: 'ms-MY', hrefLang: 'ms' },
  { code: 'zh', label: '中文', short: '中文', htmlLang: 'zh-Hans-SG', hrefLang: 'zh-Hans' },
];

export const DEFAULT_LOCALE = 'en';
export const LOCALE_CODES = LOCALES.map((entry) => entry.code);
export const LOCALE_STORAGE_KEY = 'usp.locale';

export const TRANSLATED_PATHS = [
  '/',
  '/the-group',
  '/our-businesses',
  '/governance',
  '/sustainability',
  '/newsroom',
  '/contact',
];

export function localeFor(code) {
  return LOCALES.find((entry) => entry.code === code) || LOCALES[0];
}

export function isTranslatedPath(pathname) {
  const path = (pathname || '/').replace(/\/+$/, '') || '/';
  return TRANSLATED_PATHS.includes(path);
}
